import { configureStore as createRTKStore } from '@reduxjs/toolkit';
import { api } from './state/api';

export default function configureStore(preloadedState?: Record<string, unknown>) {
  // Redux Toolkit's configureStore automatically includes:
  // - thunk middleware
  // - Redux DevTools Extension with sensible defaults
  // - immutability and serialization checks in development
  // - combineReducers (when passing an object to reducer)
  const store = createRTKStore({
    reducer: {
      // RTK Query API reducer - handles all data fetching
      [api.reducerPath]: api.reducer,
      // RTK doesn't properly infer types with computed property keys, so we use type assertion
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
    preloadedState,
    // Add RTK Query middleware for caching, invalidation, polling, etc.
    // Type assertion needed because RTK's middleware type is overly strict
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware) as any,
    // DevTools enabled in development (RTK provides good defaults)
    devTools: process.env.NODE_ENV !== 'production',
  });

  return store;
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<ReturnType<typeof configureStore>['getState']>;
export type AppDispatch = ReturnType<typeof configureStore>['dispatch'];
